import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./central-cliente-conta-listar/central-cliente-conta-listar.module').then(m => m.CentralClienteContaListarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./central-cliente-conta-detalhar/central-cliente-conta-detalhar.module').then(m => m.CentralClienteContaDetalharModule) },

  ])],
  exports: [RouterModule]
})
export class CentralClienteContaRoutingModule { }
